import { object, string } from 'yup';

import { MAX_STRING_LENGTH_YUP_TEMPLATE, REQUIRED_FIELD } from '@/config/text.const';

export const validationSchema = object().shape({
  reason: string().required(REQUIRED_FIELD).max(50, MAX_STRING_LENGTH_YUP_TEMPLATE),
});
